import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard.extend('db').add('db.breadcrumb.title', { name: 'db.index' });

const index_breadcrumbs = module.extend('db.database.index');

const show_breadcrumbs = index_breadcrumbs.extend('db.database.edit');

const db_group_breadcrumbs = module
  .extend('db.group.index')
  .add('db.breadcrumb.group.index', { name: 'db.group.index' });

const create_recipient_breadcrumbs = show_breadcrumbs.extend('db.database.recipient.create');

const edit_recipient_breadcrumbs = show_breadcrumbs.extend('db.database.recipient.edit');
const import_recipient_breadcrumbs = show_breadcrumbs.extend('db.database.import');

const db_breadcrumbs = [
  index_breadcrumbs,
  db_group_breadcrumbs,
  create_recipient_breadcrumbs,
  edit_recipient_breadcrumbs,
  import_recipient_breadcrumbs,
  show_breadcrumbs
];

export { db_breadcrumbs };
